@if (panelService.state(); as state) {
  <lib-floating-panel [title]="state.layerName" [subtitle]="subtitle()" (closed)="panelService.close()">
    <div panelHeaderActions class="d-flex align-items-center gap-1">
      <button matIconButton (click)="onFitToExtent()" aria-label="Fit to extent" matTooltip="Fit to extent">
        <mat-icon>center_focus_strong</mat-icon>
      </button>
      <lib-panel-rotate-control
        [index]="state.currentIndex"
        [count]="state.features.length"
        (previous)="panelService.previous()"
        (next)="panelService.next()"
      />
    </div>
    <div class="h-100 overflow-auto p-3">
      <lib-feature-properties-editor
        [properties]="panelService.currentFeature()?.properties ?? {}"
        [editable]="panelService.editable()"
        (save)="onSaveProperties($event)"
      />
    </div>
  </lib-floating-panel>
}
